import axios from 'axios'
import {Dispatch, FC, SetStateAction, useEffect, useState} from 'react'
import {API_URL, numberWithCommas} from '../../../../../../../_metronic/helpers'
import {CustomInputs} from '../../../../../../../_metronic/helpers/components/CustomInputs'
import {Invoice} from '../../core/_models'

type Props = {
  invoice: Invoice
  setShowPaymentModal: Dispatch<SetStateAction<boolean>>
}

const PaymentCash: FC<Props> = ({invoice, setShowPaymentModal}) => {
  const [price, setPrice] = useState('')
  const [date, setDate] = useState('')

  const pay = (prc: number) => {
    setShowPaymentModal(false)
    axios
      .post(`${API_URL}/payment/add`, {
        hash: invoice.hsh,
        price: price,
        dateTime: date,
        type: 3,
      })
      .then(() => {
        window.location.reload()
      })
  }

  useEffect(() => {
    axios.get(`${API_URL}/taxpayer/getdatetime/`).then((response) => {
      setDate(response.data)
    })
  }, [])

  useEffect(() => {
    if (Number(price) > (invoice.pymr || 0)) {
      setPrice((invoice.pymr || 0).toString())
    }
    if (Number(price) < 0) {
      setPrice('0')
    }
  }, [price])

  return (
    <>
      <div
        className='border border-1 border-primary border-dashed rounded my-5 bg-light-primary p-3 text-center fs-3x text-primary'
        onClick={() => {
          setPrice((invoice.pymr || 0).toString())
        }}
      >
        {numberWithCommas(invoice.pymr)} <span className='fs-5 text-gray-500'>ریال</span>
      </div>
      <div className='separator separator-dashed border-gray-500 mb-10'></div>
      <div className='row'>
        <div className='col-12 pt-5'>
          <CustomInputs
            type={'currency'}
            label={'مبلغ'}
            stateValue={{value: price, setValue: setPrice}}
          />
        </div>
        <div className='col-12 pt-5'>
          <CustomInputs
            type='text'
            LTR
            label={<>تاریخ و ساعت</>}
            timePicker
            stateValue={{value: date, setValue: setDate}}
          />
        </div>
        <div className='col-12 pt-5'>
          <button
            className='btn btn-success w-100 mt-5'
            onClick={() => {
              pay(Number(price))
            }}
          >
            ثبت
          </button>
        </div>
      </div>
    </>
  )
}

export {PaymentCash}
